import { useQuery } from "@tanstack/react-query";
import { fetchManagerDrilldown, fetchSupervisorSummary } from "@/api/supervisor";

const ONE_MINUTE = 60_000;

/** S2 — Supervisor Home 3-block team summary (?scope=team → supervisorSummary). */
export function useSupervisorSummary(enabled = true) {
  return useQuery({
    queryKey: ["supervisorSummary"],
    queryFn: ({ signal }) => fetchSupervisorSummary(signal),
    staleTime: ONE_MINUTE,
    enabled,
  });
}

/** Manager Drilldown (C4) — fetched on demand when a manager row is opened. */
export function useManagerDrilldown(managerId: string | null) {
  return useQuery({
    queryKey: ["managerDrilldown", managerId],
    queryFn: ({ signal }) => fetchManagerDrilldown(managerId as string, signal),
    enabled: !!managerId,
    staleTime: ONE_MINUTE,
  });
}
